<mat-form-field>
    <input matInput [matDatepicker]="picker1" placeholder="{{placeholder || ''}}" [value]="date"
        (dateChange)="change($event)" (click)="picker1.open()">
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>

</mat-form-field>